<template>
<!-- eslint-disable vue/valid-v-slot -->
  <v-container fluid>
    <!-- #region Header -->
    <printHeader class="d-none d-print-flex"></printHeader>
    <v-data-table
      :headers="headers"
      :items="wgnData"
      single-expand
      item-key="id"
      show-expand
      disable-sort
      :loading="dataLoading"
      hide-default-header
      hide-default-footer
      :no-data-text="$t('No Data Available')"
      :items-per-page="itemsPerPage"
      :page.sync="page"
      @page-count="pageCount = $event"
      :search="filterTmrCode"
      :custom-filter="filterTMR"
    >
      <template v-slot:top>
        <v-toolbar
          flat
          color="secondary darken-1"
          :height="$vuetify.breakpoint.smAndDown ?  $vuetify.breakpoint.xs ? '160px' : '100px': '70px'"
          class="d-print-none"
        >
          <v-layout wrap class="ma-0 mt-md-10">
            <v-flex xs12 md3>
              <v-toolbar-title class="mb-4 primary--text">
                {{$t('Wagons')}}
                <v-tooltip bottom>
                  <template v-slot:activator="{on}">
                    <v-btn
                      icon
                      large
                      color="primary"
                      v-on="on"
                      class="mt-0 ms-12 dense"
                      @click="csvExport"
                    >
                      <v-icon>mdi-microsoft-excel</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t('Export report data to a file in Excel format')}}</span>
                </v-tooltip>
              </v-toolbar-title>
            </v-flex>
            <v-flex xs6 sm2>
              <PickDate v-model="fromDate" @input="fromDate=$event" :label="$t('From Date')"></PickDate>
            </v-flex>
            <v-flex xs6 offset-sm-1 sm2>
              <PickDate v-model="toDate" @input="toDate=$event" :label="$t('To Date')"></PickDate>
            </v-flex>
            <v-flex xs12 offset-sm-1 sm3>
              <v-select
                flat
                class="pe-1"
                :items="dropdown_tmrs"
                v-model="filterTmrCode"
                :label="$t('Filter TMR')"
                editable
                item-value="code"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-toolbar>
        <!-- #region Printing Header -->
        <v-row class="d-none d-print-flex">
          <v-col cols="2">
            <span class="title">{{$t('Wagons')}}</span>
          </v-col>
          <v-col cols="4">
            {{$t('From Date')}}:
            <u>{{fromDate}}</u>
          </v-col>
          <v-col cols="4">
            {{$t('To Date')}}:
            <u>{{toDate}}</u>
          </v-col>
          <v-col cols="2">
            {{$t('for TMR')}}:
            <u>{{filterTmrCode || $t('All')}}</u>
          </v-col>
        </v-row>
      </template>
      <!-- #endregion -->
      <!-- <template v-slot:top>

      </template>-->
      <template v-if="$vuetify.breakpoint.smAndUp" v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th
              v-for="hdr in headers"
              :key="hdr.index"
              class="subtitle-2 font-weight-bold"
              :class="{'text-right': hdr.align == 'right', 'text-center': hdr.align == 'center'}"
            >{{hdr.text.toUpperCase()}}</th>
          </tr>
        </thead>
      </template>

      <template v-slot:item.startTime="{ item }">
        <span class="align=center">{{item.startTime | dateTimeString}}</span>
      </template>
      <template v-slot:item.status="{ item }">
        <span
          :class="{'error--text text--lighten-1': item.status >=4 }"
          class="align=center"
        >{{wagonStatus(item.status)}}</span>
      </template>
      <template v-slot:item.duration="{ item }">
        <span class="align=center">{{item.duration | duration}}</span>
      </template>
      <template v-slot:item.total="{ item }">
        <span class="align=center">{{item.wagonTotal | kgString}}</span>
      </template>
      <template v-slot:item.planed="{ item }">
        <span class="align=center">{{item.wagonPlanTotal | kgString}}</span>
      </template>
      <template v-slot:item.diff="{ item }">
        <span class="align=center">{{wagonDiff(item) | percentValue}}</span>
      </template>
      <template v-slot:expanded-item="{ item, headers }">
        <td :colspan="headers.length">
          <v-layout>
            <v-flex xs12 sm10 md6></v-flex>
          </v-layout>
          <v-layout wrap>
            <!-- #endregion -->

            <!-- #region Loadings -->
            <v-flex xs12 sm10 lg6>
              <p class="py-0 my-0">
                <span class="primary--text">{{$t('Loadings')}}:</span>
                <br />
                {{$t('Load Time')}}: {{item.loadDuration | duration}}
                <span
                  class="mx-5"
                >{{$t('Total Value')}}: {{ formatValue(item.tmrValue) }}</span>
                <span class="mx-5">{{$t('Dry Material')}}: {{item.tmrDryMaterial | percentValue}}</span>
              </p>
              <v-data-table
                :headers="loadingHeader"
                :items="item.loadings"
                item-key="order"
                hide-default-footer
                :no-data-text="$t('No Data Available')"
                class="table-border secondary lighten-1"
                dense
                disable-sort
                :loading="dataLoading"
              >
                <template v-slot:item.feedId="{ item }">
                  <span class="align=center">{{feedName(item.feedId)}}</span>
                </template>
                <template v-slot:item.qty="{ item }">
                  <span class="align=center">{{item.qty | kgString}}</span>
                </template>
                <template v-slot:item.qtyNeeded="{ item }">
                  <span class="align=center">{{item.qtyNeeded | kgString}}</span>
                </template>
                <template v-slot:item.diff="{ item }">
                  <span
                    :class="{'error--text text--lighten-1': Math.abs(item.diff) > 5 }"
                    class="align=center"
                  >{{item.diff | percentValue}}</span>
                </template>
                <template v-slot:item.startTime="{ item }">
                  <span class="align=center">{{item.startTime | timeString}}</span>
                </template>
                <template v-slot:item.status="{ item }">
                  <span
                    :class="{'error--text text--lighten-1': item.status >=4 }"
                    class="align=center"
                  >{{wagonStatus(item.status)}}</span>
                </template>
              </v-data-table>
            </v-flex>
            <!-- #endregion -->

            <!-- #region Unloadings -->
            <v-flex xs12 sm10 lg6>
              <p class="py-0 my-0">
                <span class="primary--text">{{$t('Unloadings')}}:</span>
                <br />
                <span>{{$t('Total Unloaded')}}: {{item.wagonTotalUnload | kgString}}</span>
                <span
                  class="mx-5"
                >{{$t('Unload Time')}}: {{item.duration - item.loadDuration | duration}}</span>
              </p>
              <v-data-table
                :headers="unloadingHeader"
                :items="item.unloadings"
                item-key="unloadOrder"
                hide-default-footer
                :no-data-text="$t('No Data Available')"
                class="table-border secondary lighten-1"
                dense
                disable-sort
                :loading="dataLoading"
              >
                <template v-slot:item.startTime="{ item }">
                  <span class="align=center">{{item.startTime | timeString}}</span>
                </template>
                <template v-slot:item.groupId="{ item }">
                  <span class="align=center">{{groupName(item.groupId)}}</span>
                </template>
                <template v-slot:item.qty="{ item }">
                  <span class="align=center">{{item.qty | kgString}}</span>
                </template>
                <template v-slot:item.qtyNeeded="{ item }">
                  <span class="align=center">{{item.qtyNeeded | kgString}}</span>
                </template>
                <template v-slot:item.diff="{ item }">
                  <span
                    :class="{'error--text text--lighten-1': Math.abs(item.diff) > 5 }"
                    class="align=center"
                  >{{item.diff | percentValue}}</span>
                </template>
                <template v-slot:item.status="{ item }">
                  <span class="align=center">{{wagonStatus(item.status)}}</span>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </td>
      </template>
    </v-data-table>

    <!-- #endregion -->
    <v-layout class="text-center pt-4">
      <v-flex sx12 sm3>
        <v-select
          :items="perPageList"
          :label="$t('Items per page')"
          :value="itemsPerPage"
          @input="itemsPerPage = parseInt($event, 10)"
          type="number"
          class="my-0 ml-1 mr-0 py-0"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm9>
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import PickDate from "../components/common/PickDate";
import getter from "../store/reportGetters";
import printHeader from "../components/common/PrintHeader";
export default {
  name: "ReportWagons",
  components: {
    PickDate: PickDate,
    printHeader: printHeader
  },
  data() {
    return {
      fromDate: "",
      toDate: "",
      page: 1,
      pageCount: 0,
      itemsPerPage: 25,
      filterTmrCode: "",
      dataLoading: true,
      perPageList: [
        { text: "10", value: 10 },
        { text: "25", value: 25 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
        { text: "1000", value: 1000 }
      ],
      headers: [
        {
          text: this.$i18n.t("Started at"),
          width: "22%",
          align: "left",
          value: "startTime"
        },
        {
          text: this.$i18n.t("wagon"),
          width: "12%",
          align: "left",
          value: "wagonName"
        },
        {
          text: this.$i18n.t("Duration"),
          width: "10%",
          align: "left",
          value: "duration"
        },
        {
          text: this.$i18n.t("TMR"),
          width: "8%",
          align: "left",
          value: "tmrCode"
        },
        {
          text: this.$i18n.t("Total"),
          width: "10%",
          align: "left",
          value: "total"
        },
        {
          text: this.$i18n.t("Planed"),
          width: "10%",
          align: "left",
          value: "planed"
        },
        {
          text: this.$i18n.t("Diff_"),
          width: "10%",
          align: "left",
          value: "diff"
        },
        {
          text: this.$i18n.t("Status"),
          width: "12%",
          align: "left",
          value: "status"
        }
        // { text: "Ended At", width: "", align: "left", value: "endTime" },
        // { text: "Plan Id", width: "", align: "left", value: "planWagonId" },
        // { text: "TMRid", align: "left", value: "tmrId" },
      ],
      loadingHeader: [
        {
          text: this.$i18n.t("Order"),
          width: "8%",
          align: "left",
          value: "loadOrder"
        },
        {
          text: this.$i18n.t("Started"),
          width: "12%",
          align: "left",
          value: "startTime"
        },
        {
          text: this.$i18n.t("Feed"),
          width: "26%",
          align: "left",
          value: "feedId"
        },
        {
          text: this.$i18n.t("Qty"),
          width: "14%",
          align: "left",
          value: "qty"
        },
        {
          text: this.$i18n.t("Planed"),
          width: "14%",
          align: "left",
          value: "qtyNeeded"
        },
        {
          text: this.$i18n.t("Diff_"),
          width: "11%",
          align: "left",
          value: "diff"
        },
        {
          text: this.$i18n.t("Status"),
          width: "15%",
          align: "left",
          value: "status"
        }
      ],
      unloadingHeader: [
        //{ text: "GrpCode", align: "left", value: "GrpCode" },
        {
          text: this.$i18n.t("Started"),
          width: "14%",
          align: "left",
          value: "startTime"
        },
        {
          text: this.$i18n.t("Group"),
          width: "28%",
          align: "left",
          value: "groupId"
        },
        {
          text: this.$i18n.t("Qty"),
          width: "15%",
          align: "left",
          value: "qty"
        },
        {
          text: this.$i18n.t("Planed"),
          width: "15%",
          align: "left",
          value: "qtyNeeded"
        },
        {
          text: this.$i18n.t("Diff_"),
          width: "12%",
          align: "left",
          value: "diff"
        },
        {
          text: this.$i18n.t("Status"),
          width: "16%",
          align: "left",
          value: "status"
        }
      ],
      wgnData: [
        {
          loadings: [],
          unloadings: []
        }
      ]
    };
  },
  created() {
    let d = new Date();
    d.setDate(d.getDate() - 3);
    this.fromDate = d.toISOString().substr(0, 10);
    this.toDate = new Date().toISOString().substr(0, 10);
    //list of TMRS
    this.dropdown_tmrs = this.$store.getters.getTMRs.map(function(x) {
      return { text: x.code + "-" + x.name, code: x.code + "" };
    });
    if (this.dropdown_tmrs.findIndex(x => x.code == "") == -1)
      this.dropdown_tmrs.unshift({ text: this.$i18n.t("Show All"), code: "" });
    this.loadWagonData();
  },
  watch: {
    fromDate: function() {
      if (!this.dataLoading) this.loadWagonData();
    },
    toDate: function() {
      if (!this.dataLoading) this.loadWagonData();
    }
  },
  methods: {
    loadWagonData: function() {
      this.dataLoading = true;
      getter
        .getActualWagons(this.fromDate, this.toDate, this.$store.state)
        .then(data => {
          this.wgnData = data;
          this.dataLoading = false;
        });
    },
    filterTMR(value, search, item) {
      //console.log( value, search, item);
      return search && item && item.tmrCode == search;
    },
    wagonStatus(status) {
      const wagonStatus = [
        this.$i18n.t("WIP"),
        this.$i18n.t("WIP"),
        this.$i18n.t("WIP"),
        this.$i18n.t("Ok"),
        this.$i18n.t("Review"),
        this.$i18n.t("Manual")
      ];
      return wagonStatus[status];
    },
    wagonDiff(wgn) {
      let planed = wgn.wagonPlanTotal;
      return planed
        ? Math.round(((wgn.wagonTotal - planed) * 1000) / planed) / 10
        : 0;
    },
    feedName(feedId) {
      if (!feedId) return "";
      let feed = this.$store.getters.getFeed(feedId);
      return feed.code + "-" + feed.name;
    },
    groupName(groupId) {
      if (!groupId) return "";
      let group = this.$store.getters.getGroup(groupId);
      return group ? group.code + "-" + group.name : this.$i18n.t("unknown");
    },
    // loadDiff(item) {
    //   return Math.round((item.qtyNeeded - item.qty) * 1000 / item.qtyNeeded)/10;
    // },
    timeFormat(dt) {
      if (!dt) return "";
      return dt.toLocaleDateString(undefined, { timeStyle: "short" });
      //return `${("00" + dt.getHours()).slice(-2)}:${("00" + dt.getMinutes()).slice(-2)}`
    },
    wagonValue(wgn) {
      //Todo: value stored in Kg (replace base on user preferences)
      if (wgn && wgn.tmrValue) return wgn.tmrValue;
      else return 0;
    },
    formatValue(value) {
      const currency = this.$store.getters.getCurrency;
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency,
        currencyDisplay: "symbol"
      }).format(value);
    },
    csvExport() {
      let separator = this.$store.getters.getSeparator;
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        [
          this.$i18n.t("Started at"),
          this.$i18n.t("Duration"),
          this.$i18n.t("wagon"),
          this.$i18n.t("TMR"),
          this.$i18n.t("Value"),
          this.$i18n.t("Dry Material"),
          this.$i18n.t("Status"),
          this.$i18n.t("Load Time"),
          this.$i18n.t("Total Weight"),
          this.$i18n.t("Planed"),
          this.$i18n.t("Total Unloaded")
        ].join(separator),
        ...this.wgnData.map(item =>
          [
            item.startTime,
            // item.endTime,
            item.duration,
            item.wagonName,
            item.tmrCode,
            item.tmrValue,
            item.tmrDryMaterial,
            this.wagonStatus(item.status),
            item.loadDuration,
            item.wagonTotal,
            item.wagonPlanTotal,
            item.wagonTotalUnload
            // item.tmrId,
            // item.loadings,
            // item.unloadings,
          ].join(separator)
        )
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "wagons.csv");
      link.click();
    }
  }
};
</script>

<style>
.table-border.v-table {
  border: 1px solid white !important;
  /* border-right-style: solid;
    border-right-width: 2px;
    border-right-color: azure;
    overflow-x: hidden !important; */
}
.table-border .v-data-table__wrapper {
  border: 1px solid white;
  table-layout: fixed;
}
.v-data-table td,
.v-data-table th {
  padding: 0px 4px;
}
@media print {
  *,
  *:before,
  *:after {
    background: transparent !important;
    color: #000 !important;
  }
}
</style>